import React from 'react'
import { navigations, toggleNav } from 'scripts/components/navigations/helpers/NavigationHelpers'
import { dispatcher } from '../NavigationDispatcher'
import { renderDropDown } from '../lists/ListNav'
import Constants from 'scripts/base/Constants'
import PropTypes from 'prop-types'
import {getLang} from 'shared/i18n/react'

export default class LogoDropDown extends React.Component {
  constructor(props) {
    super(props)
    this.updateDom = this.updateDom.bind(this)
    this.lang = getLang()
  }

  updateDom(data) {
    if (data.id === this.props.id) {
      toggleNav({ hidden: true, component: this }, data, this.props)
    }
  }

  componentDidMount() {
    dispatcher.on(Constants.Navigations.TOGGLE_NAV_CLASS, this.updateDom)
  }

  componentWillUnmount() {
    dispatcher.off(Constants.Navigations.TOGGLE_NAV_CLASS, this.updateDom)
  }

  renderChildren(item) {
    return renderDropDown(item, {
      listClasses: 'navbar-dropdown-item',
      aClasses: 'navbar-dropdown-link navbar-link'
    })
  }

  render() {
    return (
      <ul className={`navbar-dropdown hidden`}>
        {navigations[this.lang].soompi.map(this.renderChildren)}
      </ul>
    )
  }
}

LogoDropDown.propTypes = {
  id: PropTypes.string.isRequired,
  toggleWithId: PropTypes.func,
  dropdown: PropTypes.string
}



// WEBPACK FOOTER //
// ./assets/js/components/navigations/logo/LogoDropDown.jsx